import React from 'react'
import OpenInFullOutlinedIcon from '@mui/icons-material/OpenInFullOutlined'
import { Dialog, IconButton, useTheme } from '@mui/material'
import EventDetail from './EventDetail'

interface EventDetailDialogProps {
    eventId: string
    onRefetch: () => void
}

const EventDetailDialog: React.FC<EventDetailDialogProps> = ({ eventId, onRefetch }: EventDetailDialogProps) => {
    const theme = useTheme()
    const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(false)

    const closeDialog = () => {
        setIsDialogOpen(false)
        onRefetch()
    }

    return (
        <div>
            <IconButton onClick={() => setIsDialogOpen(true)} style={{ padding: 0, marginLeft: theme.spacing(2) }}>
                <OpenInFullOutlinedIcon fontSize='small' />
            </IconButton>
            <Dialog maxWidth='xl' fullWidth open={isDialogOpen} onClose={closeDialog}>
                <EventDetail propId={eventId} closeDialog={closeDialog} />
            </Dialog>
        </div>
    )
}

export default EventDetailDialog
